import { render } from "src/website-apps/shared/utils/render";
import { AboutUsRoot } from "./root";

render(<AboutUsRoot />);
